import { QuestionIcon } from "@phosphor-icons/react";
import { useT } from "@transifex/react";
import { useState } from "react";
import { LOGIN_COLUMN_CLASS } from "./classMemberFormStyles";

interface LoginHelpProps {
    showClassCode: boolean;
}

const LoginHelp = (props: LoginHelpProps) => {
    const t = useT();

    const [isExpanded, setIsExpanded] = useState(false);

    const t_noCode = t("Don't have a code?", { _tags: "ClassMemberLogin, LoginHelp" });
    const t_askTeacherSingle = t("Ask your teacher for your personal code.", {
        _tags: "ClassMemberLogin, LoginHelp",
    });
    const t_askTeacherBoth = t("Ask your teacher for your codes.", {
        _tags: "ClassMemberLogin, LoginHelp",
    });
    const t_scanQr = t("Or simply scan the QR code on your classroom sheet.", {
        _tags: "ClassMemberLogin, LoginHelp",
    });

    const askTeacherText = props.showClassCode ? t_askTeacherBoth : t_askTeacherSingle;
    const triggerColorClass = isExpanded ? "text-p6-orange" : "text-p6-grey-dark";
    const cardBorderClass = isExpanded ? "border-p6-grey-lightest bg-white" : "border-transparent";
    const buttonWidthClass = isExpanded ? "w-full" : "w-fit";

    return (
        <div className={LOGIN_COLUMN_CLASS}>
            <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                aria-expanded={isExpanded}
                className={`flex ${buttonWidthClass} flex-col items-center rounded-medium border bg-transparent cursor-pointer p-no focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-p6-orange ${cardBorderClass}`}
            >
                <span className="flex items-center justify-center gap-xs py-s px-s">
                    <QuestionIcon
                        size={24}
                        className={triggerColorClass}
                        aria-hidden="true"
                    />
                    <span className={`text-m text-center ${triggerColorClass} ${isExpanded ? "font-semibold" : ""}`}>
                        {t_noCode}
                    </span>
                </span>
                {isExpanded && (
                    <span className="flex w-full flex-col items-center gap-xs px-s pb-s">
                        <span className="block text-m text-p6-grey-dark w-full text-center">{askTeacherText}</span>
                        <span className="block text-m text-p6-grey-dark w-full text-center">{t_scanQr}</span>
                    </span>
                )}
            </button>
        </div>
    );
};

export default LoginHelp;
